<template>
  <div class="header container-fluid" :class="hidden ? 'hide' : ''">
    <div class="row g-0">
      <div class="left-box col-8 d-flex justify-content-start align-items-center">
        <img draggable="false" src="@/assets/img/website256.png" class="logo" @click="goto('/')" alt="dreamrail.cn" />

        <a class="nav" href="/store">{{ $t("商店") }}</a>
        <a class="nav" href="/wallpaper/square" v-if="$store.getters.isFormalLogin">{{ $t("DIY手机壁纸") }}</a>
        <a class="nav" href="/wallpaper" v-else>{{ $t("DIY手机壁纸") }}</a>
        <a class="nav" href="/wallpaper/PCsquare">{{ $t("DIY桌面壁纸") }}</a>
        <a class="nav new" href="/wallpaper/avatarSquare">{{ $t("DIY头像") }}</a>
        <a class="nav" href="/activity">{{ $t("运转和活动") }}</a>
        <a class="nav" href="/railsearch">{{ $t("铁路查询") }}</a>
        <a class="nav" href="/about">{{ $t("关于") }}</a>
        <a class="nav" href="/cooperate">{{ $t("合作") }}</a>
        <el-dropdown @command="handleCommand">
          <div class="dropdown-trigger d-sm-flex align-items-center">
            <img draggable="false" src="@/assets/img/website256.png" class="logo" alt="dreamrail.cn" />
            <span class="el-dropdown-link">
              <span class="menu-text">{{ $t("菜单") }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/">{{ $t("首页") }}</el-dropdown-item>
            <el-dropdown-item command="/store">{{ $t("商店") }}</el-dropdown-item>
            <el-dropdown-item command="/wallpaper/square" v-if="$store.getters.isFormalLogin">{{ $t("DIY手机壁纸") }}</el-dropdown-item>
            <el-dropdown-item command="/wallpaper" v-else>{{ $t("DIY手机壁纸") }}</el-dropdown-item>
            <el-dropdown-item command="/wallpaper/PCsquare">{{ $t("DIY桌面壁纸") }}</el-dropdown-item>
            <el-dropdown-item command="/wallpaper/avatarSquare">{{ $t("DIY头像") }}</el-dropdown-item>
            <el-dropdown-item command="/activity">{{ $t("运转和活动") }}</el-dropdown-item>
            <el-dropdown-item command="/railsearch">{{ $t("铁路查询") }}</el-dropdown-item>
            <el-dropdown-item command="/about">{{ $t("关于") }}</el-dropdown-item>
            <el-dropdown-item command="/cooperate">{{ $t("合作") }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="right-box col d-flex justify-content-end align-items-center">
        <template v-if="$store.getters.isFormalLogin">
          <a class="nav d-none d-sm-flex" href="javascript:void(0);" @click="$refs.GiftCodeDialog.openDialog()">
            <img src="@/assets/img/兑换.png" alt="" />
            {{ $t("礼品码兑换") }}
          </a>
          <a class="nav d-flex d-sm-none" href="javascript:void(0);" @click="$refs.GiftCodeDialog.openDialog()"><img src="https://file2.dreamrail.cn/resources/homeicon/%E7%A4%BC%E7%89%A9.svg" alt="" srcset="" /></a>
          <button class="language-btn" @click="changeLanguage">{{ $i18n.locale == "ZH" ? "EN" : "ZH" }}</button>
          <el-popover trigger="click" popper-class="user-popover" :visible-arrow="false" placement="bottom" width="310" v-model="visible" @show="refreshUser">
            <div class="user-popover-box">
              <div class="userbox">
                <h1>
                  {{ $t("个人中心") }}
                  <el-button plain size="mini" @click="$router.push('/profile')">{{ $t("账户设置") }}</el-button>
                </h1>
                <div class="user">
                  <img :src="$store.state.user.avatar" alt="" srcset="" />
                  <div class="text">
                    <h2>{{ $store.state.user.nickname || $store.state.user._email }}</h2>
                    <h3>{{ getAreaEN }}</h3>
                    <h4 v-if="$i18n.locale == 'ZH'">{{ new Date($store.state.user.created_at * 1000).format("yyyy年MM月dd日") }}注册</h4>
                    <h4 v-if="$i18n.locale == 'EN'">{{ new Date($store.state.user.created_at * 1000).format("yyyy/MM/dd") }} registered</h4>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="wallet">
                <h4>{{ $t("我的行驶里程") }}</h4>
                <span class="num">{{ $store.state.user._attribute.mileage }}{{ $t("公里") }}</span>
              </div>
              <div class="wallet">
                <h4 v-if="$i18n.locale == 'ZH'">
                  我的火车币
                  <span class="big">{{ $store.state.user._attribute.wallet }}</span>
                  枚
                </h4>
                <h4 v-if="$i18n.locale == 'EN'">
                  My RailCoin
                  <span class="big">{{ $store.state.user._attribute.wallet }}</span>
                </h4>
                <el-button type="" size="mini" plain round @click="goto('/wallet/recharge')">{{ $t("去充值") }}</el-button>
              </div>
              <div class="list">
                <a class="btn" href="/wallet?tab=2">{{ $t("我的火车券") }}</a>
              </div>
              <div class="line"></div>
              <div class="list">
                <div class="btn exit" @click="logout">{{ $t("退出登录") }}</div>
              </div>
            </div>
            <div class="user" slot="reference">
              <span class="d-flex align-items-center"><img :src="$store.state.user.avatar" alt="" srcset="" /></span>
            </div>
          </el-popover>
          <!-- <el-dropdown class="menu" @command="handleCommand">
            <span class="el-dropdown-link"> {{ $store.state.user._email }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">我的火车券</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </template>
        <template v-else>
          <a href="javascript:void(0);" @click="register">{{ $t("注册") }}</a>
          <span>|</span>
          <a href="javascript:void(0);" @click="login">{{ $t("登录") }}</a>
          <button class="language-btn" @click="changeLanguage">{{ $i18n.locale == "ZH" ? "EN" : "ZH" }}</button>
        </template>
      </div>
    </div>

    <GiftCodeDialog ref="GiftCodeDialog" />
  </div>
</template>

<script>
import GiftCodeDialog from "@/components/GiftCodeDialog.vue";
import areas from "@/assets/phone-area.json";
export default {
  name: "Header",
  components: { GiftCodeDialog },
  props: {},
  computed: {
    getAreaEN() {
      if (!this.$store.state.user._attribute.phonearea) {
        return "";
      }
      return this.areas.find((item) => item.code == this.$store.state.user._attribute.phonearea).labelen;
    }
  },
  watch: {
    $route(val) {
      console.log("path", val);
      if (val.path == "/wallpaper/draw" || val.path == "/wallpaper/drawSticker" || val.path == "/wallpaper/drawCalendar" || val.path == "/wallpaper/drawAvatar" || val.path == "/identity") {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    currentLanguage() {
      this.changeLanguage();
    }
  },
  data() {
    return {
      hidden: false,
      visible: false,
      areas: areas
    };
  },
  mounted() {
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale.toUpperCase();
    } else {
      const language = navigator.language || navigator.userLanguage;
      if (language.startsWith("en")) {
        this.$i18n.locale = "EN";
        localStorage.locale = "EN";
      } else if (language.startsWith("zh")) {
        this.$i18n.locale = "ZH";
        localStorage.locale = "ZH";
      }
    }
  },
  methods: {
    handleCommand(command) {
      this.goto(command);
    },
    refreshUser() {
      this.$BaaS.auth.getCurrentUser().then((user) => {
        console.log(user);
        if (!user._anonymous) {
          this.$store.commit("setUser", Object.assign({ login: true, isTemporaryUser: false }, user));
        }
      });
    },
    goto(target, query = {}) {
      this.visible = false;
      this.$router.push({
        path: target,
        query
      });
    },
    logout() {
      this.visible = false;
      this.$BaaS.auth.logout().then(() => {
        this.$store.commit(
          "setUser",
          Object.assign({
            login: false
          })
        );
        this.goto("/");
      });
    },
    register() {
      let to = "";
      if (this.$route.path.includes("/wallpaper")) {
        to = "/wallpaper/square";
      }
      let query = {
        mode: 1,
        to
      };
      this.goto("/login", query);
    },
    login() {
      let to = "";
      if (this.$route.path.includes("/wallpaper")) {
        to = "/wallpaper/square";
      }
      let query = {
        mode: 2,
        to
      };
      this.goto("/login", query);
    },
    changeLanguage() {
      if (this.$i18n.locale == "ZH") {
        this.$i18n.locale = "EN";
        // document.title = "";
        localStorage.locale = "EN";
      } else {
        this.$i18n.locale = "ZH";
        // document.title = "";
        localStorage.locale = "ZH";
      }
    }
  }
};
</script>
<style scoped lang="less">
* {
  transition: all 0.1s ease;
  user-select: none;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.header {
  height: 56px;
  z-index: 1000;
  top: 0px;
  transition: all ease 0.5s;
  position: sticky;
  background: var(--color-primary);
  padding: 0 20px;
  .row {
    height: 56px;
    .menu {
      margin-left: 16px;
      .el-dropdown-link {
        color: #fff;
      }
    }
    .left-box {
      .logo {
        width: 32px;
        cursor: pointer;
        margin-right: 26px;
      }
      .nav {
        margin-right: 12px;
        padding: 0 8px;
        position: relative;
        &.new {
          padding-right: 40px;
          &::after {
            content: "NEW";
            font-size: 14px;
            color: #000;
            background: var(--color-success);
            font-weight: bold;
            line-height: 1;
            display: inline-block;
            position: absolute;
            right: -6px;
            top: calc(50% - 1px);
            transform: translateY(-50%);
            padding: 1px 4px;
            border-radius: 3px;
          }
        }
      }
      a {
        color: #d1d1d1;
        text-decoration: none;
        font-size: 14px;
        &:hover {
          color: #fff;
        }
      }
      .el-dropdown {
        display: none;
      }
      .el-dropdown-link {
        color: #fff;
      }
    }
    .right-box {
      color: #fff;
      gap: 14px;
      a {
        color: #d4d4d4;
        text-decoration: none;
        font-size: 14px;
        &:hover {
          color: #fff;
        }
        img {
          width: 16px;
          height: 18px;
          vertical-align: middle;
          margin-right: 6px;
        }
      }
      .user {
        font-size: 14px;
        cursor: pointer;
        color: #d4d4d4;
        white-space: nowrap;
        img {
          width: 32px;
          border-radius: 50%;
        }
        &:hover {
          color: #fff;
        }
      }
      .language-btn {
        background: none;
        border: none;
        outline: none;
        color: #d4d4d4;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
  &.hide {
    position: fixed;
    top: -80px;
    opacity: 0;
  }
  @media screen and (max-width: 1200px) {
    height: 56px;
    .row {
      height: 56px;
      .left-box {
        flex: 0 0 auto;
        width: auto;
        & > .logo {
          display: none;
        }
        .el-dropdown {
          display: flex !important;
        }
        .dropdown-trigger {
          display: none;
          cursor: pointer;
          align-items: center;
        }
        .dropdown-trigger.d-sm-flex {
          display: flex;
        }
        .dropdown-trigger .logo {
          margin-right: 4px;
        }
        .dropdown-trigger .menu-text {
          margin-right: 4px;
          margin-left: 4px;
        }
      }
      .nav {
        display: none;
      }
    }
  }
}
</style>
<style lang="less">
.user-popover {
  background: none !important;
  border: none !important;
  overflow: hidden !important;
  border-radius: 8px !important;
  padding: 0 !important;
  color: #fff !important;
  margin-top: 22px !important;
  transform: translateX(-3px) !important;
  .user-popover-box {
    background: rgba(0, 0, 0, 0.77);
    backdrop-filter: blur(10px);
    padding-bottom: 12px;
    .userbox {
      padding: 20px 20px 5px;
      width: 100%;
      h1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 20px;
        font-family: Source Han Sans SC;
        font-weight: 700;
        color: #fff;
        font-size: 14px;
        margin: 0;
        .el-button {
          border-radius: 30px;
          background: #141414;
          color: #fff;
          border: 1px solid #666;
          height: 30px;
        }
      }
      .user {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 20px;
        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .text {
          h2 {
            line-height: 29px;
            font-family: Source Han Sans SC;
            font-weight: 700;
            color: #fff;
            font-size: 20px;
            margin: 0;
          }
          h3 {
            line-height: 18px;
            font-family: Source Han Sans SC;
            color: #fff;
            font-size: 12px;
            margin: 0;
          }
          h4 {
            line-height: 18px;
            font-family: Source Han Sans SC;
            color: #dadde1;
            font-size: 12px;
            margin: 0;
          }
        }
      }
    }
    .line {
      width: calc(100% - 40px);
      border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
      margin: 12px 20px 0 20px;
    }
    .wallet {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-top: 15px;
      padding: 0 20px;
      h4 {
        font-size: 14px;
        color: #fff;
        line-height: 20px;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .big {
          font-weight: 600;
          // font-size: 24px;
          color: var(--color-success);
          line-height: 24px;
          margin: 0 6px;
          font-size: 24px;
        }
      }
      .el-button {
        border-radius: 22px;
        background: #c7ff4a;
        color: #141414;
        border: none;
      }
      .num {
        font-weight: 400;
        color: #fff;
      }
    }
    .list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 6px;
      .btn {
        width: 100%;
        font-size: 14px;
        color: #fff;
        line-height: 20px;
        text-align: left;
        padding: 6px 20px;
        border-radius: 0;
        transition: all ease 0.1s;
        font-weight: 500;
        outline: none;
        border: none;
        &.exit {
          text-align: right;
        }
      }
    }
  }
}
</style>
